import {IHttpProvider, IHttpResponse, IQService} from "angular";
import messagesService from "../messages/messages-service";

const whitelist: { [key: number]: string[] } = {
    304: ['*'],
    400: ['session', 'rest/user/resetpassword', 'rest/user/verifysetpassword', 'rest/user/systemverifysetpassword',
        'feature/as_sosi?:', 'rest/contract/undefined/feature?destination=NVDB',
        'rest/contract/undefined/feature?destination=FKB'],
    401: ['*'],
    404: ['session',
        'nvdbapiles-v3.test.atlas.vegvesen.no/veg?vegsystemreferanse:',
        'nvdbapiles-v3.atlas.vegvesen.no/veg?vegsystemreferanse:'],
    410: ['*'],
    422: ['/veg',
        'nvdbapiles-v3.test.atlas.vegvesen.no/veg?vegsystemreferanse:',
        'nvdbapiles-v3.atlas.vegvesen.no/veg?vegsystemreferanse:',
        'nvdbapiles-v3.test.atlas.vegvesen.no/beta/vegnett/rute:',
        'nvdbapiles-v3.atlas.vegvesen.no/beta/vegnett/rute:'],
    431: ['/rest/vegobjekter:'],
    503: ['status/healthchecks']
};
export default function interceptors($httpProvider: IHttpProvider) {
        $httpProvider.interceptors.push(messagesInterceptor);
}
function messagesInterceptor($q: IQService, messages: messagesService) {

    function isWhitelisted(status: number, url: string) {
        const paths = whitelist[status];
        if (!paths) {
            return false;
        } else if (paths.indexOf('*') != -1) {
            return true;
        } else {
            return paths.some(function(path) {
                if ( path.indexOf(':') === -1 ) {
                    // returns whether url ends with any of the paths
                    return url.indexOf(path, url.length - path.length) !== -1;
                } else {
                    // If whitelist ends in a ':', check for it in the entire path
                    return url.indexOf(path.substring(0, path.length-1)) !== -1;
                }
            });
        }
    }

    function operationPath(rejection: IHttpResponse<any>) {
        return rejection.config.url.substring(rejection.config.url.lastIndexOf('/') + 1);
    }

    return {
        responseError: (rejection: IHttpResponse<any>) => {
            if (rejection.status === 431 && rejection.config.url.startsWith("/rest/vegobjekter")) {
                let header = "Kunne ikke hente ut vegobjekter fra NVDB";
                let message = "Vi klarer ikke å hente så mange vegobjekter på en gang.";
                messages.info(message, header);
            }
            if (!isWhitelisted(rejection.status, rejection.config.url)) {
                const operationDescription = (rejection.config as any).description || operationPath(rejection);
                if(operationDescription.includes("Lese veg fra referanselenke")){
                    return;
                }
                if (rejection.status == 404) {
                    let header = operationDescription;
                    let message = "Dette kunne ikke utføres fordi noe du har etterspurt ikke finnes i datasystemene.";
                    messages.danger(message, header);
                } else if (rejection.status == 500) {
                    let header = operationDescription;
                    let message = "Systemfeil! En feil i baksystemene hindrer dette fra å gjennomføres. Hvis problemet vedvarer, ta kontakt med support.";
                    messages.danger(message, header);
                } else if (rejection.status == 403) {
                    let header = operationDescription;
                    let message = "Brukeren din mangler rettigheter til å utføre dette.";
                    messages.danger(message, header);
                } else if (rejection.status == 413) {
                    let header = operationDescription;
                    let message = "Dette kunne ikke gjennomføres fordi filene er for stor.";
                    messages.danger(message, header);
                } else {
                    let header = operationDescription;
                    let message;
                    if (rejection.data?.message) {
                        message = rejection.data.message;
                    } else if (Array.isArray(rejection.data?.messages)) {
                        message = (rejection.data.messages as string[]).join("\n");
                    } else {
                        message = "Noe gikk galt, men du kan prøve igjen. Hvis problemet vedvarer, ta kontakt med support.";
                    }
                    messages.danger(message, header);
                }
            }
            return $q.reject(rejection);
        }
    };
}
interceptors.$inject = ['$httpProvider'];
messagesInterceptor.$inject = ['$q', 'messages'];
